var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper-settings w-100 pt-4"},[_c(_vm.currentComponent,{tag:"component",staticClass:"px-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }